<template>
  <form @submit.prevent="submit" class="notification mt-9 mt-lg-0">
    <div class="d-flex flex-row align-content-center container-back">
      <button class="bg-transparent border-0" @click="cancel">
        <i class="icon-angle-left"></i>
      </button>

      <h5>Adicionar notificação</h5>
    </div>
    <hr />

    <form-group
      class="mt-6"
      v-model="form.type"
      id="type-notification"
      label="Tipo de notificação"
      placeholder="Selecionar"
      select
      :options="notificationTypes"
      :errors="errors.type"
    />

    <form-group
      class="mt-6"
      v-model="form.greater"
      id="type-notification"
      type="number"
      label="Mostrar a partir de"
      placeholder="Nosso sistema exibirá a partir dessa quantidade."
      :errors="errors.greater"
    />

    <div class="d-flex justify-content-between mt-9">
      <button
        type="button"
        v-if="!Number.isInteger(notificationToEdit)"
        class="btn btn-fixed-size btn-outline-secondary"
        @click="cancel"
      >
        Cancelar
      </button>
      <button
        v-else
        type="button"
        class="btn btn-fixed-size btn-outline-danger"
        :class="{
          'btn-outline-danger': !loadingRemove,
          'btn-danger': loadingRemove
        }"
        @click="toggleModal"
      >
        <loading :show="loadingRemove">
          Excluir notificação
        </loading>
      </button>
      <div class="mx-3"></div>
      <button
        class="btn btn-fixed-size"
        :class="isValid ? 'btn-primary ' : 'btn-secondary'"
        :disabled="!isValid"
        type="submit"
      >
        <loading :show="loading">
          Salvar notificação
        </loading>
      </button>
    </div>

    <confirmation
      v-model="modalDeleteVisible"
      @confirm="removeNotification"
      @cancel="toggleModal"
      :confirmButtonClass="'btn-danger'"
      :text="'Tem certeza que deseja excluir essa notificação?'"
    />
  </form>
</template>
<script>
import { formFields } from "@/functions/helpers.js";

export default {
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    notificationToEdit: {
      type: Number,
      default: null
    },
    notificationTypes: {
      type: Array,
      default: () => []
    },
    productId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      loadingRemove: false,
      ...formFields(["type", "greater", "product_id"], {
        product_id: this.productId
      }),
      modalDeleteVisible: false
    };
  },
  mounted() {
    if (Number.isInteger(this.notificationToEdit)) {
      this.form = JSON.parse(
        JSON.stringify(this.notifications[this.notificationToEdit])
      );
    }
  },
  computed: {
    isValid() {
      return this.form.type && this.form.greater;
    }
  },
  methods: {
    submit() {
      this.loading = true;

      let action = "notifications/post";
      let event = "saveNewNotification";

      if (Number.isInteger(this.notificationToEdit)) {
        action = "notifications/put";
        event = "saveEditNotification";
      }

      this.$store
        .dispatch(action, this.form)
        .then(response => {
          this.$emit(event, response.data);
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeNotification() {
      this.loadingRemove = true;

      this.$store
        .dispatch(
          "notifications/delete",
          this.notifications[this.notificationToEdit].id
        )
        .then(() => {
          this.$emit("remove");
        })
        .finally(() => {
          this.loadingRemove = false;
        });
    },
    toggleModal() {
      this.modalDeleteVisible = !this.modalDeleteVisible;
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
.notification {
  .container-back {
    i {
      font-size: 24px;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
</style>
